import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalTextStylesBoldBlack } from 'globalStyles';
import Risk from 'models/risk';

interface IListRiskScoreProps {
  risk: Risk;
  timeline: 'start' | 'current' | 'goal';
}

const ListRiskScore = (props: IListRiskScoreProps) => {
  let score: number;
  let likelihood: number;
  let impact: number;
  let dim3d: number;

  switch (props.timeline) {
    case 'start':
      score = props.risk.getStartScore();
      likelihood = props.risk.likelihoodStart;
      impact = props.risk.impactStart;
      dim3d = props.risk.dim3Start;
      break;
    case 'current':
      score = props.risk.getCurrentScore();
      likelihood = props.risk.likelihoodCurrent;
      impact = props.risk.impactCurrent;
      dim3d = props.risk.dim3Current;
      break;
    case 'goal':
      score = props.risk.getGoalScore();
      likelihood = props.risk.likelihoodGoal;
      impact = props.risk.impactGoal;
      dim3d = props.risk.dim3Goal;
      break;
    default:
      return null;
  }

  //
  // Main render
  //
  return (
    <IPStack
      horizontalAlign="center"
      styles={{
        root: { minWidth: 50, maxWidth: 50, backgroundColor: props.risk.riskMatrix?.getColor(likelihood, impact, dim3d) },
      }}
    >
      <IPText styles={globalTextStylesBoldBlack}>{score}</IPText>
    </IPStack>
  );
};

export default ListRiskScore;
